import { Button } from "@jutro/ui";
import {
  EdmGetAllShiftsDocument,
  EdmMedicalAppShiftWithoutVisitFragment,
  useEdmCancelShiftsConfirmationMutation,
  useEdmConfirmShiftsMutation,
} from "lib/graphql/megaSchema";
import { toaster } from "lib/tools/toaster";

type Props = {
  shift: EdmMedicalAppShiftWithoutVisitFragment;
};

export const ActionsCell = ({ shift }: Props) => {
  const [
    cancelShiftsConfirmation,
    { loading: isCancelShiftsConfirmationLoading },
  ] = useEdmCancelShiftsConfirmationMutation();
  const [confirmShifts, { loading: isConfirmShiftsLoading }] =
    useEdmConfirmShiftsMutation();

  const isConfirmed = shift.confirmed;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();

    if (isConfirmed) {
      const cancelShiftConfirmationPromise = cancelShiftsConfirmation({
        variables: { input: { shiftIds: [shift.id] } },
        refetchQueries: [EdmGetAllShiftsDocument],
      });

      toaster.promise(cancelShiftConfirmationPromise, {
        loading: "Odwołuje obecność...",
        success: "Poprawnie odwołano obecność",
        error: "Wystąpił błąd",
      });
      return;
    }

    const confirmShiftPromise = confirmShifts({
      variables: { input: { shiftIds: [shift.id] } },
      refetchQueries: [EdmGetAllShiftsDocument],
    });

    toaster.promise(confirmShiftPromise, {
      loading: "Potwierdzam obecność...",
      success: "Poprawnie potwierdzono obecność",
      error: "Wystąpił błąd",
    });
  };

  return (
    <div className="relative w-fit min-w-64">
      <div className="group-hover:jm-opacity-100 absolute opacity-0">
        <Button
          size="condensed"
          full={false}
          text={isConfirmed ? "Odwołaj obecność" : "Potwierdź obecność"}
          variant={isConfirmed ? "negative" : "primary"}
          onClick={handleClick}
          loading={isCancelShiftsConfirmationLoading || isConfirmShiftsLoading}
        />
      </div>

      {isConfirmed && (
        <div className="group-hover:jm-opacity-0 font-paragraph-1 pointer-events-none absolute">
          Potwierdzono obecność
        </div>
      )}
    </div>
  );
};
